// extracted by css-extract-rspack-plugin
export default {"ActionMenuButton":"NotificationsSubscriptionsMenu-module__ActionMenuButton__FVE3w","subscriptionDialog":"NotificationsSubscriptionsMenu-module__subscriptionDialog__cEs3l"};